import React, { useState } from 'react';
import { Modal } from 'antd';
import useDeleteTenant from '../mutations/useDeleteTenant';
import ConfirmContent from '../components/ui/modals/AddTenantModal/components/ConfirmContent';
import { checkAddressRemoval } from '../../../queries/useCheckAddressRemovalQuery';

const confirm = Modal.confirm;

const useDeleteTenantComfirm = () => {
  const [isLoadingCheck, setIsLoadingCheck] = useState(false);

  const { mutateAsync, isLoading } = useDeleteTenant();

  const isLoadingDeleteTenant = isLoading || isLoadingCheck;

  const handleConfirm = ({ autoInfo = false, address, phone }) => {
    return new Promise((resolve) => {
      confirm({
        title: 'Удалить привязку к адресу?',
        content: (
          <ConfirmContent autoInfo={autoInfo} address={address} phone={phone} />
        ),
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
      });
    });
  };

  const handleDeleteTenant = async (values = {}) => {
    const { tenantId, tenantBindId, address, addressId, phone, onOk } = values;

    setIsLoadingCheck(true);

    const data = await checkAddressRemoval({
      clientId: tenantId,
      addressId,
    });

    setIsLoadingCheck(false);

    const comfirmed = await handleConfirm({
      autoInfo: data.success,
      address,
      phone,
    });

    if (comfirmed) {
      await mutateAsync(tenantBindId);

      if (typeof onOk === 'function') {
        onOk();
      }
    }
  };

  return { handleDeleteTenant, isLoadingDeleteTenant };
};

export default useDeleteTenantComfirm;
